import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserCompanyUiFeaturesType } from '@shared/api/graphql/generated';

import { buildFeatureFlags } from './consts';

import { setRuntimeFlags, setBuildFlags, setIsLoading } from './slice';

export const initializeFeatureFlags = createAsyncThunk(
  'featureFlags/initialize',
  async (uiFeatures: UserCompanyUiFeaturesType | undefined, { dispatch }) => {
    dispatch(setIsLoading(true));

    try {
      if (uiFeatures) {
        dispatch(setRuntimeFlags(uiFeatures));
      }

      dispatch(setBuildFlags(buildFeatureFlags));

      const consoleFlags = (window as any).consoleFeatureFlagsWindow?.featuresConsole;

      if (consoleFlags) {
        dispatch(setBuildFlags(consoleFlags));
      }
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);
